import config from "../config";
const axios = require('axios');

export default {
    // called when the user attempts to log in
    login: ({ username, password }) => {
        return axios
            .post(config.API_HOST+'/administrators/login', {
                email: username,
                password: password
            })
            .then(res => {
                if(res.status == 200)
                    localStorage.setItem('token', res.data.token);
                return Promise.resolve();
            })
            .catch(error => {
                return Promise.reject("Les identifiants fournis ne sont pas valides.");
            });
    },
    // called when the user clicks on the logout button
    logout: () => {
        localStorage.removeItem('token');
        return Promise.resolve();
    },
    // called when the API returns an error
    checkError: ({ status }) => {
        if (status === 401 || status === 403) {
            localStorage.removeItem('token');
            return Promise.reject("Vous n'avez pas les permissions nécessaires.");
        }
        return Promise.resolve();
    },
    // called when the user navigates to a new location, to check for authentication
    checkAuth: () => {
        return localStorage.getItem('token')
            ? Promise.resolve()
            : Promise.reject();
    },
    // called when the user navigates to a new location, to check for permissions / roles
    getPermissions: () => Promise.resolve(),
};